var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"aside-brand d-flex flex-column align-items-center flex-column-auto py-4 py-lg-8"},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{staticClass:"max-h-30px",attrs:{"src":"media/logos/jci-white-logo.png","alt":"Logo"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }